import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/global-assets/4.0.1/legacy/0/images/logo_immowelt.svg'
import _imports_1 from '../assets/global-assets/4.0.1/legacy/0/images/logo_immowelt_blank.svg'


const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_1
const _hoisted_3 = { class: "signin-formOuterWrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", {
    media: "(min-width: 981px)",
    srcset: _hoisted_1,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    media: "(max-width: 980px)",
    srcset: _hoisted_2,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "signin-formInnerWrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Anmelden", -1)
const _hoisted_8 = { class: "inputfield" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "E-Mail oder Benutzername: ", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "inputfield" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Passwort:", -1)
const _hoisted_14 = { class: "password-area" }
const _hoisted_15 = ["disabled", "type"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "signin-additional-login-fields" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  id: "remember-me-inputfield",
  class: "signin-remember-me-inputfield"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "remember-me-input",
    class: "remember-me-input",
    type: "checkbox",
    name: "rememberMe"
  }),
  /*#__PURE__*/_createTextVNode(" angemeldet bleiben? ")
], -1)
const _hoisted_20 = { id: "password-forgotten-inputfield" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  id: "signin-privacy-info",
  class: "signin-privacy"
}, " Diese Verbindung ist sicher. ", -1)
const _hoisted_23 = { class: "signin-formSwitch" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, "Neu bei Immowelt?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          href: "//www.immowelt.de",
          title: "Immowelt",
          class: "signin-logoWrap"
        }, _hoisted_5),
        _createElementVNode("form", {
          id: "loginForm",
          action: "https://signin.immowelt.de/?target=meinbereich&path=%2Fredirect",
          method: "post",
          onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.bussy,
                  id: "user-name-input",
                  type: "text",
                  tabindex: "1",
                  name: "userName",
                  class: _normalizeClass({'error': _ctx.formErrors.email.length}),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.username) = $event))
                }, null, 10, _hoisted_10), [
                  [_vModelText, _ctx.formData.username]
                ]),
                (_ctx.formErrors.email.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formErrors.email), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: _ctx.bussy,
                    id: "password-input",
                    type: _ctx.passtype,
                    class: _normalizeClass({'error': _ctx.formErrors.password.length}),
                    name: "password",
                    tabindex: "2",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event))
                  }, null, 10, _hoisted_15), [
                    [_vModelDynamic, _ctx.formData.password]
                  ]),
                  (_ctx.formErrors.password.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formErrors.password), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    disabled: _ctx.bussy,
                    id: "toggle-password",
                    type: "button",
                    class: _normalizeClass({'hidden-password': _ctx.passtype === 'password', 'show-password': _ctx.passtype === 'text'}),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleIcon && _ctx.toggleIcon(...args)))
                  }, null, 10, _hoisted_17)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                      id: "passwordForgottenLink",
                      class: "signin-link signin-forgot",
                      href: "//immowelt.de/zugangsdaten/passwort/vergessen"
                    }, " Passwort vergessen? ")
                  ])
                ]),
                _createElementVNode("input", {
                  disabled: _ctx.bussy,
                  id: "signin-button",
                  class: "signin-button signin-button--primary signin-button--big",
                  type: "submit",
                  value: "Anmelden",
                  tabindex: "3"
                }, null, 8, _hoisted_21)
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                  id: "RegisterFormButton",
                  href: "//immowelt.de/myiw/meineimmowelt/index.aspx?registervisible",
                  class: "signin-button signin-button--black"
                }, " Jetzt kostenfrei registrieren ")
              ])
            ])
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}